import { withAsyncLoading } from '../../../../components/withAsyncLoading';
export const MagicLinkPageLoading = withAsyncLoading(async () => import('./MagicLinkPage').then(res => res.MagicLinkPage));

